import { render, staticRenderFns } from "./UserTask.vue?vue&type=template&id=5652ad73&"
import script from "./UserTask.vue?vue&type=script&lang=js&"
export * from "./UserTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5652ad73')) {
      api.createRecord('5652ad73', component.options)
    } else {
      api.reload('5652ad73', component.options)
    }
    module.hot.accept("./UserTask.vue?vue&type=template&id=5652ad73&", function () {
      api.rerender('5652ad73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/penal/task/task-components/UserTask.vue"
export default component.exports